import { ColumnDef, ModelDef } from '@shared/model'
import { AxE2ConfigModelDef } from '../services/$AxE2Config'
import { $axFrontendHelper } from '../services/$axFrontendHelper'

interface Columns {
  [colName: string]: ColumnDef
}

interface CustomOrderMasterData {
  code: string // "malony_order_wrapping01"
  id: string // "40"
  name: string // "包装紙のみ"
}

const getCustomOrderSelectionsBySystemName = async (
  system_name: string,
  reformatForSelect = false
): Promise<CustomOrderMasterData[]> => {
  const res = await $axFrontendHelper.request({
    path: '/utility/custom_master/get',
    data: {
      query: {
        entity_class: 'order',
        system_name: system_name,
      },
    },
  })
  const selections = res.result.selections
  if (reformatForSelect) {
    return selections.map((sel) => ({
      text: sel.name,
      value: sel,
    }))
  }
  return selections
}

export const cartAdditionalInputsColumns: Columns = {
  id: {
    type: 'STRING',
    visible: false,
  },
  // malony_order_noshi: {
  //   type: 'STRING',
  //   label: 'のし選択',
  //   strictSelections: true,
  //   selections: async ($store, record, currentValue, initialValue): Promise<CustomOrderMasterData[]> => {
  //     return getCustomOrderSelectionsBySystemName("malony_order_noshi")
  //   },
  //   customLabel: ({ name }) => name,
  // },
  // malony_order_wrapping: {
  //   type: 'STRING',
  //   label: '包装紙選択',
  //   strictSelections: true,
  //   selections: async ($store, record, currentValue, initialValue): Promise<CustomOrderMasterData[]> => {
  //     return getCustomOrderSelectionsBySystemName("malony_order_wrapping")
  //   },
  //   customLabel: ({ name }) => name || 'なし',
  // },
}

const generateCartAdditionalColumn = (keyName, label, isSelect = false, additionalColDef: any = {}) => {
  if (isSelect) {
    return {
      type: 'SELECT',
      label,
      strictSelections: true,
      selections: function () {
        return getCustomOrderSelectionsBySystemName(keyName, additionalColDef.inputAttrs?.radio)
      },
      customLabel: ({ name }) => name || '',
      ...additionalColDef,
    }
  } else {
    return {
      type: 'STRING',
      label,
      ...additionalColDef,
    }
  }
}

export const cartAdditionalInputs: ModelDef & AxE2ConfigModelDef<any> = {
  tableName: 'cartAdditionalInputs',
  tableLabel: 'カート追加フォーム',
  defaultSort: { key: 'createdAt', order: 'desc' },
  timestamps: false,
  columns: cartAdditionalInputsColumns,
  modelMethods: {
    getCustomOrderSelectionsBySystemName,
    generateCartAdditionalColumn,
  },
}
